import { Button, IconNames, Spinner, Text } from '@sendible/design-system';
import { AltLabelBadge, Container } from './index.styles';

interface Props {
  icon: IconNames;
  isDisabled?: boolean;
  isLoading?: boolean;
  label: string;
  onClick: () => void;
  altLabel?: string;
}

export const ActionButton = ({ icon, isDisabled, isLoading, label, onClick, altLabel }: Props) => (
  <Container>
    {isLoading ? (
      <Spinner size="sm" />
    ) : (
      <Button
        onClick={onClick}
        darkmode
        disabled={isDisabled}
        icon={icon}
        size={18}
        title={isDisabled ? '' : label}
      />
    )}
    <Text
      color={isDisabled || isLoading ? 'brandLightAlpha50' : 'brandLight'}
      variation="body_12"
    >
      {label}
    </Text>
    {altLabel && <AltLabelBadge>{altLabel}</AltLabelBadge>}
  </Container>
);
